import {
  customElement,
  DeesElement,
  property,
  html,
  TemplateResult,
  css,
  cssManager,
} from '@designestate/dees-element';

declare global {
  interface HTMLElementTagNameMap {
    'lele-logingate': LeleLoginGate;
  }
}

@customElement('lele-logingate')
export class LeleLoginGate extends DeesElement {
  public static demo = () => html`<lele-logingate>
    <lele-statusbar></lele-statusbar>
    a test text
  </lele-logingate>`;

  @property({
    type: Boolean,
    attribute: true,
    reflect: true,
  })
  public loggedIn = false;

  constructor() {
    super();
  }

  public static styles = [
    cssManager.defaultStyles,
    css`
      :host {
        position: absolute;
        width: 100%;
        height: 100%;
      }

      .slotContainer {
        height: 100%;
        width: 100%;
        opacity: 0;
        transition: all 0.2s;
        transition-delay: 0.2s;
        transform: translate3d(0px, 20px, 0px);
      }

      :host([loggedIn]) .slotContainer {
        opacity: 1;
        transform: translate3d(0px, 0px, 0px);
      }

      .loginblockContainer {
        background: ${cssManager.bdTheme('#eeeeeb', '#000000')};
        position: absolute;
        top: 0px;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 1;
        transition: all 0.2s;
      }

      :host([loggedIn]) .loginblockContainer {
        opacity: 0;
        pointer-events: none;
      }

      .loginblock {
        flex-grow: 1;
        transform: translate3d(0px, 0px, 0px);
        transition: all 0.2s;
      }

      :host([loggedIn]) .loginblock {
        transform: translate3d(0px, 20px, 0px);
      }

      img {
        width: 130px;
        min-height: 34.9px;
        display: block;
        margin: auto;
        margin-top: 0px;
        margin-bottom: 25px;
        filter: ${cssManager.bdTheme('invert(1)', '')};
      }

      .legalinfo {
        text-align: center;
        margin: auto;
        margin-top: 10px;
        color: ${cssManager.bdTheme('#666', '#ccc')};
      }

      .legalinfo a {
        color: ${cssManager.bdTheme('#666', '#ccc')};
        text-decoration: none;
        font-size: 12px;
      }
    `,
  ];

  render() {
    return html`
      <div class="slotContainer">
        <slot></slot>
      </div>

      <div class="loginblockContainer">
        <div class="loginblock">
          <img src="https://assetbroker.lossless.one/brandfiles/lossless/svg-minimal-bright.svg" />
          <lele-login></lele-login>
          <div class="legalinfo">
            <a href="https://lossless.gmbh/" target="_blank">Legal Info</a>
            | <a href="https://lossless.com/" target="_blank">Company Website</a> |
            <a href="https://lossless.support/" target="_blank">Support</a>
          </div>
        </div>
      </div>
    `;
  }

  public firstUpdated() {
    const leleLogin = this.shadowRoot.querySelector('lele-login');
    leleLogin.jwtObserable.subscribe({
      next: async (jwtArg) => {
        console.log('loggedIn');
        this.loggedIn = true;
      },
    });
    leleLogin.dispatchJwt();
  }
}
